<div *ngIf="formFactoryField$ | async as formFactoryFieldRef">
    <label *ngIf="formFactoryFieldRef.label" [for]="'attachment-file-' + idCount">
        {{ formFactoryFieldRef.label }}
    </label>
    <input type="file" [id]="'attachment-file-' + idCount" name="attachmentFile" (change)="onFileChange($event)" />
</div>
